<template>
  <div>
    <van-cell-group>
      <van-cell v-for="course in courseList" :key="course.courseId" @click="viewCourse(course)">
        <template slot="title">
          <van-row>
            <van-col span="6" class="course-image">
              <img :src="getImageUrl(course.courseImageUri)">
            </van-col>
            <van-col span="18" class="course-name">
              {{ course.courseName }}
            </van-col>
          </van-row>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import courseApi from '@/api/course'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  name: 'CourseVideoList',
  props: {
    categoryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      courseList: [],
      clientInfo: null
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    load () {
      if (!this.categoryId) {
        return
      }
      this.queryCourseVideoList()
    },
    queryCourseVideoList () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取课程信息'
      })
      const params = {
        categoryId: this.categoryId,
        pageSize: 10
      }
      courseApi.queryCourseList(params).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.courseList = response.data.resultData.courseList
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    viewCourse (course) {
      if (!this.clientInfo) {
        this.$dialog.alert({
          confirmButtonText: '确定',
          message: '请先登录再访问视频内容'
        }).then(() => {
          window.location.href = commonUtils.getExtraSite() + '/#/login'
        })
      } else {
        const isLocalVideo = course.courseFileLink.toLowerCase().indexOf('img.bosch-extra.com.cn') > -1
        if (isLocalVideo) {
          this.$router.push({ name: 'course-video', query: { course: JSON.stringify(course) } })
        } else {
          window.open(course.courseFileLink)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.course-image {
  text-align: center;

  img {
    max-width: 100%;
    max-height: 60px;
  }
}
.course-name {
  line-height: 60px;
}
</style>
